// DESCRIPTION: Final screen — three action tiles taking the user to the
// booking page preview, sample event editor, or dashboard.

import { __ } from '@wordpress/i18n';
import WizardShell from '../components/WizardShell';

/**
 * @since PBOOKING_SINCE
 *
 * @param {Object} props
 * @param {Object} props.finalizeResult { pages: {book: 12, ...}, sample_event_id: 89 }
 *
 * @return {JSX.Element}
 */
export default function DoneStep( { finalizeResult } ) {
	const config = window.nemtlyBookingSetup || {};
	const adminUrl = config.adminUrl || '/wp-admin/';

	const bookPageId = finalizeResult?.pages?.book;
	const sampleEventId = finalizeResult?.sample_event_id;

	const previewUrl = bookPageId
		? `${ config.siteUrl || '' }/?page_id=${ bookPageId }`
		: null;

	const eventEditUrl = sampleEventId
		? `${ adminUrl }admin.php?page=nemtly-booking#/events/${ sampleEventId }`
		: null;

	const dashboardUrl = `${ adminUrl }admin.php?page=nemtly-booking`;

	return (
		<WizardShell stepKey="done" hideFooter>
			<div className="nemtly-wizard-done">
				<h2 className="nemtly-wizard-headline">
					{ __( "You're ready to take bookings.", 'nemtly-booking' ) }
				</h2>
				<p className="nemtly-wizard-lede">
					{ __(
						'Your booking page is live and a sample event is waiting. Take it for a spin.',
						'nemtly-booking'
					) }
				</p>

				<div className="nemtly-wizard-done-tiles">
					{ previewUrl && (
						<a
							className="nemtly-wizard-tile"
							href={ previewUrl }
							target="_blank"
							rel="noopener noreferrer"
						>
							<span className="nemtly-wizard-tile__title">
								{ __(
									'Preview your booking page',
									'nemtly-booking'
								) }
							</span>
							<span className="nemtly-wizard-tile__desc">
								{ __(
									'See what your customers will see.',
									'nemtly-booking'
								) }
							</span>
						</a>
					) }
					{ eventEditUrl && (
						<a className="nemtly-wizard-tile" href={ eventEditUrl }>
							<span className="nemtly-wizard-tile__title">
								{ __(
									'Edit your sample event',
									'nemtly-booking'
								) }
							</span>
							<span className="nemtly-wizard-tile__desc">
								{ __(
									'Make it yours by changing title, time, price.',
									'nemtly-booking'
								) }
							</span>
						</a>
					) }
					<a
						className="nemtly-wizard-tile nemtly-wizard-tile--primary"
						href={ dashboardUrl }
					>
						<span className="nemtly-wizard-tile__title">
							{ __( 'Open dashboard', 'nemtly-booking' ) }
						</span>
						<span className="nemtly-wizard-tile__desc">
							{ __(
								'Jump into Nemtly Booking.',
								'nemtly-booking'
							) }
						</span>
					</a>
				</div>
			</div>
		</WizardShell>
	);
}
